import { render, staticRenderFns } from "./LoaderTable.vue?vue&type=template&id=552e52d9&scoped=true&"
var script = {}
import style0 from "./LoaderTable.vue?vue&type=style&index=0&id=552e52d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552e52d9",
  null
  
)

export default component.exports